export default "__VITE_ASSET__CEsmqrlE__"